import ScanRewardCardModal from 'components/GlobalModals/ScanRewardCardModal/ScanRewardCardModal';
import withGlobalModals from 'hocs/withGlobalModals';

export default withGlobalModals(ScanRewardCardModal);
